import { render, staticRenderFns } from "./UnterrichtAdditionalKnowledgeForB.vue?vue&type=template&id=ebffe336&scoped=true"
import script from "./UnterrichtAdditionalKnowledgeForB.vue?vue&type=script&lang=ts"
export * from "./UnterrichtAdditionalKnowledgeForB.vue?vue&type=script&lang=ts"
import style0 from "./UnterrichtAdditionalKnowledgeForB.vue?vue&type=style&index=0&id=ebffe336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebffe336",
  null
  
)

export default component.exports